import React from 'react';

export const DEFAULT = 'idle';
export const SUCCESS = 'resolved';
export const ERROR = 'rejected';
export const LOADING = 'loading';

export const state = {
  DEFAULT,
  SUCCESS,
  ERROR,
  LOADING,
};

function Loader() {
  return (
    <div className="loader__box">
      <div className="loader" />
      <p className="loader__text">Ładowanie...</p>
    </div>
  );
}

export default Loader;
